import React from 'react';
import { Desc, Title } from './index.styles';

import { useTranslation } from 'react-i18next';
import BoundariesLCA from './BoundariesContent';

interface Props {
  values: any;
  setValues: Function;
}

export default function Boundaries({ setValues, values }: Props) {
  const { t } = useTranslation('lca');
  return (
    <div>
      <Title>{t('boundaries.title')}</Title>
      <Desc dangerouslySetInnerHTML={{ __html: t('boundaries.desc') }} />
      <BoundariesLCA values={values} setValues={setValues} />
    </div>
  );
}
